module.exports = __webpack_public_path__ + "img/inter-v11-latin-600.918cbe6.svg";